import { withActionDialogLock } from "@/action-dialog/actionDialogLock";
import {
  LibraryAddModeCallable,
  type LibraryAddModeCallableProps,
} from "@/action-dialog/callables/LibraryAddModeCallable";
import type { LibraryAddMode } from "@/action-dialog/dialogs/LibraryAddModeDialog";
import { alwaysAddAsReference } from "@/action-dialog/libraryAddModePreference";

export type { LibraryAddMode } from "@/action-dialog/dialogs/LibraryAddModeDialog";

/**
 * The reference-or-copy chooser for same-workspace Add from Library picks
 * (canvas and chat). Resolves null when dismissed — the pick is abandoned.
 * The dialog's "always add as a live reference" checkbox stores a skip:
 * once set, the chooser resolves to reference without showing (reset in
 * Settings → Account). Cross-workspace picks use their own workflow and
 * always ask.
 */
export function runLibraryAddModeWorkflow(
  params: LibraryAddModeCallableProps,
): Promise<LibraryAddMode | null> {
  if (alwaysAddAsReference()) return Promise.resolve("reference");
  return withActionDialogLock(() => LibraryAddModeCallable.call(params));
}
